import { render, staticRenderFns } from "./upload-drawer-xml.vue?vue&type=template&id=3f73122e&scoped=true"
import script from "./upload-drawer-xml.vue?vue&type=script&lang=js"
export * from "./upload-drawer-xml.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f73122e",
  null
  
)

export default component.exports